import React from "react";

const cases = [
  { icon: "🏗️", title: "Residential Townships", desc: "Dedicated fast charging infrastructure for residential communities with centralized energy and billing management." },
  { icon: "🏢", title: "Commercial Complexes", desc: "Ideal for malls, office parks, and commercial campuses where EV demand is growing but installation space is limited." },
  { icon: "🚛", title: "Fleet & Logistics Hubs", desc: "Dedicated fast charging for commercial fleets, delivery vehicles, trucks, and e-buses operating on demanding turnaround schedules." },
  { icon: "🛣️", title: "Highway Corridors", desc: "High-speed corridor charging for highways and transit routes requiring rapid deployment and reliable uptime." },
  { icon: "🏨", title: "Hotels & Hospitality", desc: "Premium EV charging amenity for hotels, resorts, and hospitality environments with space-efficient deployment requirements." },
  { icon: "🏭", title: "Industrial Campuses", desc: "Industrial and warehouse EV charging for employee fleets, commercial vehicles, and high-mileage operations." },
  { icon: "🏙️", title: "Smart City Nodes", desc: "Urban public charging hubs integrated with smart payment, monitoring, and city-level energy management ecosystems." },
  { icon: "⛽", title: "Fuel Station Retrofits", desc: "Seamless EV charging integration for existing fuel stations and forecourt infrastructure." },
];

export default function UseCasesSection() {
  return (
    <section className="usecases" id="usecases">
      <div className="container">
        <p className="section-label reveal">Where It Fits</p>
        <h2 className="section-title reveal">
          Built for Every <br />Charging Environment
        </h2>
        <p className="section-sub reveal">
          VerdeMobility's Mini DC Charger's compact form opens up locations
          where larger units simply can't go.
        </p>
        <div className="usecases-grid">
          {cases.map((c) => (
            <div className="usecase-card reveal" key={c.title}>
              <span className="usecase-icon">{c.icon}</span>
              <div className="usecase-title">{c.title}</div>
              <p className="usecase-desc">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
